import { abyssColors, primary } from '@/theme/colors';
import { Skeleton, Stack, Typography, alpha, styled as muiStyled } from '@mui/material';

interface StackContainerProps {
  selected?: boolean;
}

interface GroupBoxProps {
  widthPercentage?: number;
  color?: string;
  first?: boolean;
  last?: boolean;
  selected?: boolean;
}

interface ColorIndicatorProps {
  color?: string;
}

export const Widget = muiStyled(Stack)(() => ({
  background: primary.ghostWhite,
  border: `0.2rem solid ${alpha(primary.gray, 0.25)}`,
  padding: '3.2rem',
  borderRadius: '0.8rem',
}));

export const StackedColorBar = muiStyled(Stack)(
  ({ selected, widthPercentage, color, first, last }: GroupBoxProps) => ({
    border: selected ? '2px solid #000' : 'none',
    height: '1.6rem',
    width: widthPercentage ? `${widthPercentage}%` : '100%',
    background: color || abyssColors.neutral[400],
    borderRadius: first ? '2rem 0 0 2rem' : last ? '0 2rem 2rem 0' : '0',
  })
);

export const StackContainer = muiStyled(Stack)(({ selected }: StackContainerProps) => ({
  background: selected ? 'rgb(101 130 164 / 15%)' : 'transparent',
  padding: '0.2rem 0.5rem',
  borderRadius: '0.8rem',
}));

export const LegendColor = muiStyled('span')(({ color }: ColorIndicatorProps) => ({
  width: '1rem',
  height: '1rem',
  backgroundColor: color,
  borderRadius: '50%',
  marginBottom: '0.2rem',
}));

export const LegendCount = muiStyled(Typography)(() => ({
  color: primary.independence,
  fontWeight: 700,
  fontSize: '1.6rem',
  lineHeight: '3.2rem',
}));

export const LegendLabel = muiStyled(Typography)(() => ({
  color: primary.independence,
  fontSize: '1.2rem',
  lineHeight: 'normal',
  letterSpacing: '-0.012rem',
  fontWeight: 400,
}));

export const CustomSkeleton = muiStyled(Skeleton)(() => ({
  background: 'transparent',
  transform: 'unset',
  width: '2.6rem',
  height: '4.6rem',
  borderRadius: '0.4rem',
}));

export const StackSkeleton = muiStyled(Skeleton)(() => ({
  background: 'transparent',
  transform: 'unset',
  width: '100%',
  height: '1.6rem',
  borderRadius: '2rem',
}));
